import React from "react";

const defaultBehavior = {};

const ConfigContext = React.createContext(defaultBehavior);

export default ConfigContext;
